module.exports = "img/flags/CN.2564087.png";